import { PracticeAdminConsole } from '@/components/dashboard/PracticeAdminConsole';

export function PracticeAdminPage() {
  return <main className="min-h-full bg-[var(--sp-bg)] text-[var(--sp-text)]"><PracticeAdminConsole /></main>;
}
